import React, { FC, ReactElement } from 'react';
import {Col, Row} from "antd";
import {GUTTER} from "../../../constants";
import {AnswerOptimalityPieChartCard} from "../components/DialogueChoises/AnswerOptimalityPieChartCard";
import {SectionPerformanceCard} from "../components/Generic/SectionPerformanceCard";
import {FeedbackRowProps} from "./types";

export const DialogueChoicesRow: FC<FeedbackRowProps> = ({attemptId, activityId, style}): ReactElement => (
    <Row gutter={GUTTER} style={style}>
        <Col xs={24} xl={12}>
            <AnswerOptimalityPieChartCard attemptId={attemptId} activityId={activityId}/>
        </Col>
        <Col xs={24} xl={12}>
            <SectionPerformanceCard type='dialogue-choices' attemptId={attemptId} activityId={activityId}/>
        </Col>
    </Row>
);
